import axios, { AxiosPromise } from 'axios';

import { EnumAutocomplete } from '../type';

let axiosInstance = axios;

export const getEnumValues = (
  baseUrl: string,
  enumClass: string
): AxiosPromise<EnumAutocomplete[]> => {
  return axiosInstance.get(`${baseUrl}/get-enum-values/${enumClass}`);
};

export const setAxiosInstance = (instance: typeof axios) => {
  axiosInstance = instance;
};
